<html>
 <head>
  <title>ALB Heartbeat</title>
 </head>
 <body>
   <p>OK</p>
 </body>
</html>